module.exports = __webpack_public_path__ + "components/flag/static/square/et-2e908ce1bab1df61eacfe7dc6a43d69f.svg";